export default __webpack_public_path__ + "static/media/DanskeNarrow-Italic.bac7ed7f.ttf";